export default __webpack_public_path__ + "static/media/resume.413e3c30.pdf";